/**
 * The ISO ↔ house-format conversions `DateField` draws with.
 *
 * A separate module from the components themselves so the field file
 * exports components only (`react-refresh/only-export-components`), and
 * so the mask can be unit-tested without a DOM.
 */
import { formatDate, formatDateTime } from '../../utils/date-format';

export const DATE_PLACEHOLDER = 'DD/MMM/YYYY';
export const DATE_TIME_PLACEHOLDER = 'DD/MMM/YYYY, --:--';

/**
 * `YYYY-MM-DD` → `22/Jul/2026`.
 *
 * Parsed as string components and rebuilt with the LOCAL `Date`
 * constructor rather than handed to `new Date(value)`: a date-only ISO
 * string parses as UTC midnight per the spec, so reading local getters
 * back off it shifts the displayed day by one everywhere behind UTC.
 * Anything that is not a complete ISO date is returned untouched — a
 * half-typed value must not flicker through a wrong-looking date.
 */
export function formatIsoDate(value: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!m) return value;
  return formatDate(new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
}

/** `YYYY-MM-DDTHH:mm[:ss]` → `22/Jul/2026, 14:35`. Same local-fields
 *  reconstruction as `formatIsoDate`, for the same reason. */
export function formatIsoDateTime(value: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(value);
  if (!m) return value;
  return formatDateTime(
    new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), Number(m[4]), Number(m[5])),
  );
}
